import { ActionCode } from "./api";
import { ERoutes } from "./AppRouter";
import { INavigationItem } from "./components";

export const BaseAppNavigation: INavigationItem[] = [
  {
    name: "Dashboard",
    route: ERoutes.dashboard,
    icon: "dashboard",
    actions: [ActionCode.ViewDashboard],
  },
  {
    name: "Agents",
    route: ERoutes.agents,
    icon: "people",
    actions: [ActionCode.ViewAgent],
  },
  {
    name: "Dossiers",
    route: ERoutes.dossiers,
    icon: "folder-close",
    actions: [ActionCode.ViewAgent],
  },
  {
    name: "Configuration",
    alternativeIcon: "fa-solid fa-screwdriver-wrench",
    actions: [],
    items: [
      {
        name: "FunctionAndDirectorList",
        route: ERoutes.functions,
        alternativeIcon: "fa-solid fa-medal",
        actions: [ActionCode.ViewFunction],
      },
      {
        name: "FunctionalDirectorList",
        route: ERoutes.functionalDirectors,
        alternativeIcon: "fa-solid fa-medal",
        actions: [ActionCode.ViewFunction],
      },

      {
        name: "GradeFunctions",
        route: ERoutes.gradeFunctions,
        alternativeIcon: "fa-solid fa-graduation-cap",
        actions: [ActionCode.ViewGradeFunctions],
      },
      {
        name: "Mentions",
        icon: "star",
        route: ERoutes.mentions,
        actions: [ActionCode.ViewMention],
      },
      {
        name: "FormQuestions",
        icon: "properties",
        route: ERoutes.formQuestions,
        actions: [ActionCode.ViewFormQuestion],
      },
      {
        name: "ObjectiveQuestionList",
        icon: "properties",
        route: ERoutes.objectiveQuestions,
        actions: [ActionCode.ViewObjectiveQuestion],
      },
      {
        name: "FormQuestionOperationals",
        icon: "properties",
        route: ERoutes.formQuestionOperationals,
        actions: [ActionCode.ViewFormQuestion],
      },
      {
        name: "CancellationReasons",
        icon: "properties",
        route: ERoutes.cancellationReasons,
        actions: [ActionCode.ViewCancellationReason],
      },
    ],
  },
  {
    name: "Administration",
    icon: "cog",
    actions: [],
    items: [
      {
        name: "Users",
        icon: "people",
        route: ERoutes.users,
        actions: [ActionCode.ViewUser],
      },
      {
        name: "ActionRoles",
        icon: "hat",
        route: ERoutes.actionRoles,
        actions: [ActionCode.EditActionGroup],
      },
      {
        name: "Translations",
        icon: "text-highlight",
        route: ERoutes.translations,
        actions: [ActionCode.EditTranslations],
      },
      {
        name: "DataTranslations",
        icon: "data-connection",
        route: ERoutes.dataTranslations,
        actions: [ActionCode.EditDataTranslations],
      },
    ],
  },
];

// Fonction pour remplir le tableau actions de l'objet Administration
const populateAdministrationActions = (navigation) => {
  for (const item of navigation) {
    if (item.name === "Administration") {
      const allActions = [];
      item.items.forEach((subItem) => {
        if (subItem.actions) {
          allActions.push(...subItem.actions);
        }
        if (subItem.items) {
          subItem.items.forEach((nestedSubItem) => {
            if (nestedSubItem.actions) {
              allActions.push(...nestedSubItem.actions);
            }
          });
        }
      });
      item.actions = allActions;
      break; // Sortir de la boucle une fois que nous avons trouvé et mis à jour l'élément Administration
    }
  }
};

// Appel de la fonction pour mettre à jour l'objet
populateAdministrationActions(BaseAppNavigation);

const InnerFindAppNavigationItemFromRoute = (
  pathname: string,
  navItem: INavigationItem
): INavigationItem | null => {
  if (navItem?.route && pathname.startsWith(navItem.route)) {
    return navItem;
  }
  const nextNavItems = navItem.items;
  if (nextNavItems && nextNavItems?.length > 0) {
    for (const i of nextNavItems) {
      const found = InnerFindAppNavigationItemFromRoute(pathname, i);
      if (found) {
        return found;
      }
    }
  }
  return null;
};

export const FindAppNavigationItemFromRoute = (pathname: string) => {
  for (const i of BaseAppNavigation) {
    const found = InnerFindAppNavigationItemFromRoute(pathname, i);
    if (found) return found;
  }
  return null;
};
